import type { JsonFormsRendererRegistryEntry } from "@jsonforms/core";
import S3FileUploadControl, { s3FileUploadControlTester } from "./S3FileUploadControl";

/**
 * App-owned renderers passed to `CloudscapeJsonForms` via `customRenderers`.
 *
 * These cover behaviour the library deliberately leaves out because it is
 * application-specific — S3 uploads through this service's presigned-URL API,
 * for one. The library stays consumer-agnostic; this is where the claim intake
 * specifics live.
 *
 * Exported as a module-level constant so the array identity is stable, which
 * `CloudscapeJsonForms` needs to avoid rebuilding its renderer registry on
 * every render.
 */
export const claimIntakeRenderers: JsonFormsRendererRegistryEntry[] = [
  { tester: s3FileUploadControlTester, renderer: S3FileUploadControl },
];

export { S3FileUploadControl, s3FileUploadControlTester };
export { useS3AttachmentTarget } from "./useS3AttachmentTarget";
export type { S3AttachmentTarget } from "./useS3AttachmentTarget";
